import useAxios from '@/composables/useAxios';
import TaskToDoApiResponse from '@/interfaces/Api/TaskToDoApiResponse';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';

const currentTaskConfig = ref<TaskToDoApiResponse | null>(null);

/**
 * This composable manages the student's progress by switching the task view depending
 * on the task configuration received from the API.
 */
export default function useTaskProgress() {
    const axios = useAxios();
    const router = useRouter();

    async function getTaskToDo(): Promise<TaskToDoApiResponse | null> {
        try {
            const response = await axios.get('student/progress/task');
            const taskConfigResponse = response.data as TaskToDoApiResponse;
            currentTaskConfig.value = taskConfigResponse;
            return taskConfigResponse;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    /**
     * Allows to manually set the current task configuration when joining the test session, for example.
     * @param taskConfig
     */
    function setCurrentTaskConfig(taskConfig: TaskToDoApiResponse | null) {
        currentTaskConfig.value = taskConfig;
    }

    /**
     * Automatically change the task view when the task configuration changes.
     */
    watch(currentTaskConfig, (newConfig) => {
        if (!newConfig || !router) {
            return;
        }
        if (newConfig.status === 'SESSION_ENDED') {
            router.push({
                name: `homepage`,
            });
        } else if (newConfig.status === 'TASK_TODO') {
            router.push({
                name: `tasks.${newConfig.task_code}`,
            });
        }
    });

    return {
        getTaskToDo,
        setCurrentTaskConfig,
        currentTaskConfig,
    };
}
